import React from 'react';
import BarSplitChart from './BarSplitChart';
import { getQuestionnaireCode } from '../../../utils/questionnaireOptions';

// Show the short payment-term code on the Y axis instead of the long
// description so the axis labels stay compact and don't overlap.
const toCodes = (rows) =>
  rows.map((row) => ({
    ...row,
    name: getQuestionnaireCode('supplier_term_of_payment', row.name),
  }));

const PaymentTermsSplitChart = () => (
  <BarSplitChart
    title="Split Over Payment Terms"
    endpoint="/dashboard/payment-terms-split"
    cornerLabel="count · %"
    barColor="var(--dash-chart-1)"
    maxRows={7}
    showPercent
    transform={toCodes}
    sortToggle
  />
);

export default PaymentTermsSplitChart;
